import {
  ActivationDocumentTypes,
  AllDocumentTypes,
  DocumentTypes,
  documentTitles,
  InterconnectionAgreementDocumentType,
  MilestoneType,
} from 'types';

import FormSection from '../Forms/FormSection';
import { MarketSpecificRequirementsDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';

import { DocumentList } from './Documents/DocumentList';

type MarketSpecificRequirementsProps = {
  originContext: string;
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories?: AllDocumentTypes[];
  milestoneType: MilestoneType;
  isPackageEditable?: boolean;
};

export const MarketSpecificRequirements = ({
  originContext,
  allowArchive,
  showCheckboxes = false,
  checkboxCategories = [],
  milestoneType,
  isPackageEditable = true,
}: MarketSpecificRequirementsProps) => {
  return (
    <FormSection
      description={MarketSpecificRequirementsDescription(milestoneType)}
      title="Market Specific Requirements"
    >
      <DocumentList
        documentTypeFilter={[
          ActivationDocumentTypes.incentives,
          InterconnectionAgreementDocumentType.interconnectionAgreement,
          DocumentTypes.disclosure,
          ActivationDocumentTypes.cslbDisclosure,
          ActivationDocumentTypes.puertoRicoDocuments,
          ActivationDocumentTypes.welcomeCall,
          ActivationDocumentTypes.onSitePhysicalSurvey,
          ActivationDocumentTypes.proofOfEquipment,
        ]}
        title="Market Specific Requirements"
        baseCategory={documentTitles.incentiveDocuments}
        uploadContext={originContext}
        allowArchive={allowArchive}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
